<template>
  <div class="text-xs-center">
    <v-bottom-sheet :value="actionPopupTrigger" :hide-overlay="true" :persistent="true">
      
      <v-card tile>
        <v-progress-linear
          :value="50"
          class="my-0"
          height="3"
        ></v-progress-linear>

        <v-list>
          <v-list-tile>
            <v-list-tile-content>
              
              <v-list-tile-sub-title>Fitz & The Trantrums</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-spacer></v-spacer>

            <v-list-tile-action>
              <v-btn icon>
                <v-icon>fast_rewind</v-icon>
              </v-btn>
            </v-list-tile-action>

            <v-list-tile-action :class="{ 'mx-5': $vuetify.breakpoint.mdAndUp }">
              <v-btn icon>
                <v-icon>pause</v-icon>
              </v-btn>
            </v-list-tile-action>

            <v-list-tile-action :class="{ 'mr-3': $vuetify.breakpoint.mdAndUp }">
              <v-btn icon>
                <v-icon>fast_forward</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import store from "@/store"

  export default {
    ...mapState({
      transactionStatus: state => state.contractsDb.transactionStatus
    }),
    computed: {
      
    },
    mounted: function () {
      
    },
    watch: {
      transactionStatus: function () {
        if (this.transactionStatus.item == 'sent') {
          this.actionPopupTrigger = true 
        } else {
          this.actionPopupTrigger = false 
        }
      }
    },
    data () {
      return {
        actionPopupTrigger: true,
        snackbar: false,
        color: '',
        mode: '',
        timeout: 6000
      }
    }
  }
</script>